var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 24,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.59 32.531c-0.15-0.17-3.782-4.176-9.459-8.23-3.35-2.394-6.72-4.301-10.016-5.674-4.176-1.741-8.253-2.624-12.115-2.624s-7.939 0.883-12.115 2.624c-3.296 1.373-6.666 3.283-10.016 5.674-5.677 4.054-9.309 8.064-9.459 8.23-0.547 0.608-0.547 1.533 0 2.141 0.15 0.17 3.782 4.176 9.459 8.23 3.35 2.394 6.72 4.301 10.016 5.674 4.176 1.741 8.253 2.624 12.115 2.624s7.939-0.883 12.115-2.624c3.296-1.373 6.666-3.283 10.016-5.674 5.677-4.054 9.309-8.064 9.459-8.23 0.547-0.608 0.547-1.533 0-2.141zM40.237 20.602c2.902 2.442 4.563 5.994 4.563 9.798 0 7.059-5.741 12.8-12.8 12.8s-12.8-5.741-12.8-12.8c0-3.802 1.661-7.357 4.563-9.798 2.63-0.858 5.411-1.402 8.237-1.402s5.606 0.544 8.237 1.402v0zM52.214 40.339c-4.906 3.494-12.394 7.661-20.214 7.661s-15.309-4.166-20.214-7.661c-3.702-2.637-6.534-5.306-7.965-6.739 1.43-1.434 4.262-4.099 7.965-6.739 1.696-1.21 3.699-2.496 5.92-3.664-1.11 2.202-1.706 4.656-1.706 7.203 0 8.822 7.178 16 16 16s16-7.178 16-16c0-2.547-0.595-5.002-1.706-7.203 2.221 1.168 4.224 2.458 5.92 3.664 3.702 2.637 6.534 5.306 7.965 6.739-1.43 1.434-4.262 4.099-7.965 6.739z",
    fill: "#095797"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoir);
export default __webpack_public_path__ + "static/media/voir.2c7bbc4d612784466a8e1bb6bcf521f7.svg";
export { ForwardRef as ReactComponent };